import Header from '../../../../Components/Header';
import SingleSignOnSideBar from '../../../../Components/SingleSignOnSideBar';
import '../HufNreDetails/hufnredetails.scss';
import searchIba from '../../../../asset/images/ibaimages/searchIba.svg';
import IbaAgentAllDetails from '../../componentiba/IbaAgentAllDetails/IbaAgentAllDetails';

import { useEffect, useState, useRef, useCallback } from 'react';
import axios from 'axios';
import debounce from 'lodash.debounce';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { HUFNREDASHBAORD } from '../../../../Configuration/Telecaller_URl';

const HufNreDetails = () => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [pageStatus, setPageStatus] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);

  const [agents, setAgents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  // ================= PAGINATION STATES =================
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize] = useState(10);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const tableBodyRef = useRef(null);

  const navigate = useNavigate();

  const [showRejectModal, setShowRejectModal] = useState(false);
  const [selectedDocumentType, setSelectedDocumentType] = useState('');
  const [rejectionReasons, setRejectionReasons] = useState([]);
  const [selectedReason, setSelectedReason] = useState(null);

  // ======================================================
  // DOWNLOAD
  // ======================================================

  const handleDownload = (data) => {
    if (data?.downloadLink) {
      const link = document.createElement('a');
      link.href = data.downloadLink;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';

      link.setAttribute('download', 'document.pdf');

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  // ======================================================
  // SEARCH
  // ======================================================

  const handleSearch = useCallback(
    debounce((value) => {
      setSearchTerm(value.trim());

      // RESET PAGINATION
      setPageNumber(1);
      setAgents([]);
      setHasMore(true);
    }, 400),
    []
  );

  // ======================================================
  // GET AGENT DETAILS
  // ======================================================

  const getAgentDetails = async (currentPage = 1) => {
    if (loading) return;

    setLoading(true);

    const payload = {
      searchValue: searchTerm,
      page_number: currentPage,
      page_size: pageSize,
    };

    try {
      const response = await axios.post(
        HUFNREDASHBAORD.hufnrelist,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            reserv: 0,
            Authorization: `Bearer ${localStorage.getItem('ssoToken')}`,
          },
        }
      );

      const data = response.data;

      if (data.status === 0) {
        const newApplications = data?.data?.applications || [];

        // FIRST PAGE => REPLACE DATA
        if (currentPage === 1) {
          setAgents(newApplications);
        } else {
          // NEXT PAGE => APPEND DATA
          setAgents((prev) => [...prev, ...newApplications]);
        }

        // CHECK MORE DATA AVAILABLE
        if (newApplications.length < pageSize) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      } else {
        toast.error(data?.message);

        if (currentPage === 1) {
          setAgents([]);
        }

        setHasMore(false);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  // ======================================================
  // REJECT REASONS
  // ======================================================

  const getRejectedResoan = async () => {
    try {
      const response = await axios.get(
        HUFNREDASHBAORD.rejectedresoan,
        {
          headers: {
            'Content-Type': 'application/json',
            reserv: 0,
            Authorization: `Bearer ${localStorage.getItem('ssoToken')}`,
          },
        }
      );

      const data = response.data;

      if (data.status === 0) {
        setRejectionReasons(data?.data.document_types);
      } else {
        toast.error(data?.message);
        setRejectionReasons([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ======================================================
  // REJECT REASON SELECTED
  // ======================================================

  const getRejectedResoanSelected = async (value) => {
    try {
      const response = await axios.get(
        HUFNREDASHBAORD.rejectedresoan,
        {
          params: {
            document_type: value,
          },
          headers: {
            'Content-Type': 'application/json',
            reserv: 0,
            Authorization: `Bearer ${localStorage.getItem('ssoToken')}`,
          },
        }
      );

      const data = response.data;

      if (data.status === 0) {
        setSelectedReason(data?.data.reasons);
      } else {
        toast.error(data?.message);
        setSelectedReason([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ======================================================
  // HANDLE DOCUMENT TYPE
  // ======================================================

  const handleDocumentTypeChange = (e) => {
    const value = e.target.value;

    setSelectedDocumentType(value);
    setSelectedReason(null);

    getRejectedResoanSelected(value);
  };

  // ======================================================
  // HANDLE CHECKBOX
  // ======================================================

  const handleCheckboxChange = (reason) => {
    setSelectedReason(reason);
  };

  // ======================================================
  // SCROLL PAGINATION
  // ======================================================

  const handleScroll = () => {
    const table = tableBodyRef.current;

    if (!table || loading || !hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = table;

    // REACHED BOTTOM
    if (scrollTop + clientHeight >= scrollHeight - 20) {
      setPageNumber((prev) => prev + 1);
    }
  };

  // ======================================================
  // INITIAL API
  // ======================================================

  useEffect(() => {
    getRejectedResoan();
  }, []);

  // ======================================================
  // SEARCH / PAGE CHANGE API
  // ======================================================

  useEffect(() => {
    getAgentDetails(pageNumber);
  }, [pageNumber, searchTerm]);

  // ======================================================
  // PERFORMANCE
  // ======================================================

  const handlePerformance = (agentData) => {
    navigate('/performance-reports', {
      state: {
        agent: agentData,
      },
    });
  };

  // ======================================================
  // ACCEPT
  // ======================================================

  const handleAccept = async (data) => {
    const payload = {
      mobileNumber: data.mobileNumber,
      status: 'APPROVED',
      accountType: data.type,
    };

    try {
      const response = await axios.post(
        HUFNREDASHBAORD.updatestatus,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            reserv: 0,
            Authorization: `Bearer ${localStorage.getItem('ssoToken')}`,
          },
        }
      );

      const responseData = response.data;

      if (responseData.status === 0) {
        setShowConfirmation(true);

        // REFRESH LIST
        setPageNumber(1);
        setAgents([]);

        getAgentDetails(1);
      } else {
        toast.error(responseData?.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // ======================================================
  // REJECT
  // ======================================================

  const [rejectData, setRejectData] = useState(null);

  const handleReject = (data) => {
    setSelectedReason(null);
    setSelectedDocumentType('');
    setRejectData(data);

    setShowRejectModal(true);
  };

  // ======================================================
  // REJECT SUBMIT
  // ======================================================

  const handleRejectSubmit = async () => {
    if (!selectedDocumentType) {
      toast.error('Please select rejection type');
      return;
    }

    if (!selectedReason?.id) {
      toast.error('Please select rejection reason');
      return;
    }

    const payload = {
      mobileNumber: rejectData?.mobileNumber || '',
      status: 'REJECTED',
      accountType: rejectData?.type || '',
      rejectionId: selectedReason.id,
      reason: selectedReason.error,
      documentType: selectedDocumentType,
    };

    try {
      const response = await axios.post(
        HUFNREDASHBAORD.updatestatus,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            reserv: 0,
            Authorization: `Bearer ${localStorage.getItem('ssoToken')}`,
          },
        }
      );

      const data = response.data;

      if (data.status === 0) {
        toast.success(data?.data.message);

        setShowRejectModal(false);

        // REFRESH LIST
        setPageNumber(1);
        setAgents([]);

        getAgentDetails(1);
      } else {
        setShowRejectModal(false);
        toast.error(data?.message);
      }
    } catch (err) {
      setShowRejectModal(false);
      console.log(err);
    }
  };

  return (
    <div>
      <Header portal={'IBA'} />

      <SingleSignOnSideBar />
        <main id="main-content" className="telecallerDash">
          <div className="card-box iba-page hufnre">
            <div className="agent-table-wrapper">
              <div className="wrap-header performance-report">
                <div className="module-title">List of Client</div>

                <div className="search-bar">
                  <img src={searchIba} alt="searchIba" />

                  <input
                    type="text"
                    placeholder="Enter Client Name or Pan"
                    onChange={(e) => handleSearch(e?.target?.value)}
                  />
                </div>
              </div>

              <table className="agent-table mt-4 ag-details-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>PAN</th>
                    <th>Email ID</th>
                    <th>Account Type</th>
                    <th>Date of Application</th>
                    <th>Status</th>
                    <th>Download AOF</th>
                    <th style={{ paddingLeft: "50px" }}>Action</th>
                  </tr>
                </thead>

                <tbody
                  ref={tableBodyRef}
                  onScroll={handleScroll}
                  style={{
                    display: 'block',
                    maxHeight: '500px',
                    overflowY: 'auto',
                  }}
                >
                  {agents?.length === 0 ? (
                    <tr>
                      <td
                        colSpan="8"
                        style={{
                          textAlign: 'center',
                          padding: '10px',
                        }}
                      >
                        No Client Found
                      </td>
                    </tr>
                  ) : (
                    <>
                      {agents?.map((data, index) => (
                        <tr key={index}>
                          <td>{data?.name}</td>

                          <td>{data?.pan}</td>

                          <td>{data?.emailId}</td>

                          <td>{data?.type}</td>

                          <td>
                            {data?.applicationDate
                              ? new Date(data.applicationDate)
                                .toLocaleDateString('en-GB')
                                .replace(/\//g, '-')
                              : ''}
                          </td>

                          {/* <td>{data?.status}</td> */}
                          <td>
                            <span
                              className={`status-badge ${data?.status === "Pending"
                                  ? "pending-status"
                                  : data?.status === "Approved"
                                    ? "approved-status"
                                    : data?.status === "Rejected"
                                      ? "rejected-status"
                                      : ""
                                }`}
                            >
                              {data?.status}
                            </span>
                          </td>

                          <td>
                            <div className="details-cell">
                              <span
                                className="link"
                                onClick={() => handleDownload(data)}
                              >
                                Download
                              </span>
                            </div>
                          </td>

                          {/* <td>
                            <div className="action-cell">
                              <img
                                src="/Imgs/accept.svg"
                                alt="Accept"
                                className="action-icon"
                                onClick={() => handleAccept(data)}
                              />

                              <img
                                src="/Imgs/reject.svg"
                                alt="Reject"
                                className="action-icon"
                                onClick={() => handleReject(data)}
                              />
                            </div>
                          </td> */}
                          <td>
  <div className="action-cell">
    <img
      src="/Imgs/accept.svg"
      alt="Accept"
      className={`action-icon-huf ${
        data?.status !== "Pending" ? "disabled-action" : ""
      }`}
      onClick={() =>
        data?.status === "Pending" && handleAccept(data)
      }
    />

    <img
      src="/Imgs/reject.svg"
      alt="Reject"
      className={`action-icon-huf ${
        data?.status !== "Pending" ? "disabled-action" : ""
      }`}
      onClick={() =>
        data?.status === "Pending" && handleReject(data)
      }
    />
  </div>
</td>
                        </tr>
                      ))}

                      {/* LOADER */}
                      {loading && (
                        <tr>
                          <td
                            colSpan="8"
                            style={{
                              textAlign: 'center',
                              padding: '15px',
                            }}
                          >
                            Loading...
                          </td>
                        </tr>
                      )}

                      {/* NO MORE DATA */}
                      {!hasMore && agents.length > 0 && (
                        <tr>
                          <td
                            colSpan="8"
                            style={{
                              textAlign: 'center',
                              padding: '15px',
                            }}
                          >
                            No More Data
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </main>
    

      {/* CONFIRMATION POPUP */}

      {showConfirmation && (
        <div className="confirmation-overlay ">
          <div className="confirmation-popup">
            <div className="popup-header">Confirmation</div>

            <div className="popup-body">
              <h3>Application Accepted</h3>

              <p>You have successfully approved the application</p>

              <button
                className="okay-btn"
                onClick={() => setShowConfirmation(false)}
              >
                OKAY
              </button>
            </div>
          </div>
        </div>
      )}

      {/* REJECT MODAL */}

      {showRejectModal && (
        <div className="confirmation-overlay">
          <div className="confirmation-popup reject-popup">
            <div className="popup-header">Reject Master</div>

            <div className="popup-body">
              {/* DOCUMENT TYPE */}

              <div className="field-group">
                <label>Select Rejected Step</label>

                {/* <select
                  value={selectedDocumentType}
                  onChange={handleDocumentTypeChange}
                  className="reject-dropdown"
                >
                  <option value="">Select Rejected Step</option>

                  {rejectionReasons?.map((item, index) => (
                    <option key={index} value={item.documentType}>
                      {item.documentType}
                    </option>
                  ))}
                </select> */}
                <select
                  value={selectedDocumentType}
                  onChange={handleDocumentTypeChange}
                  className="reject-dropdown"
                >
                  <option value="">Select Rejected Step</option>

                  {rejectionReasons?.map((item, index) => (
                    <option key={index} value={item.documentType}>
                      {item.documentType}
                    </option>
                  ))}
                </select>
              </div>

              {/* REASONS */}

              {selectedReason?.length > 0 && (
                <div className="checkbox-section">
                  <h4>Select Rejection Reason</h4>

                  {selectedReason.map((item) => (
                    <div className="checkbox-item" key={item.id}>
                      <input
                        type="checkbox"
                        checked={selectedReason?.id === item.id}
                        onChange={() => handleCheckboxChange(item)}
                      />

                      <span>{item.error}</span>
                    </div>
                  ))}
                </div>
              )}

              {/* BUTTONS */}

              {/* {selectedReason?.length > 0 && ( */}
                <div className="reject-btn-group">
                  <button
                    className="cancel-btn"
                    onClick={() => setShowRejectModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="submit-btn-rejected"
                    onClick={handleRejectSubmit}
                  >
                    Submit
                  </button>
                </div>
              {/* )} */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HufNreDetails;